import { render, staticRenderFns } from "./BorrowTable.vue?vue&type=template&id=0c1556b4&"
import script from "./BorrowTable.vue?vue&type=script&lang=js&"
export * from "./BorrowTable.vue?vue&type=script&lang=js&"
import style0 from "./BorrowTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports